import type { JSX } from 'react'

import { IconProps, iconColor } from './IconProps'

export function NavigationDownSmallIcon(props: IconProps): JSX.Element {
  const size = props.size || 12

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 12 12'
      fill='none'
      className={props.className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 4.00012L2 4.00012L5.35925 7.70723C5.71312 8.09775 6.28688 8.09775 6.64075 7.70723L10 4.00012Z'
        fill={iconColor(props)}
      />
    </svg>
  )
}
